/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_DraftInputs */

const en_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const es_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador`)
};

const fr_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon`)
};

const de_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

const ja_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き`)
};

const zh_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿`)
};

const ar_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسودة`)
};

const id_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf`)
};

const it_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza`)
};

const ru_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновик`)
};

const pt_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho`)
};

const ko_listing_status_draft = /** @type {(inputs: Listing_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임시저장`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Listing_Status_DraftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_draft = /** @type {((inputs?: Listing_Status_DraftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_DraftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_draft(inputs)
	if (locale === "es") return es_listing_status_draft(inputs)
	if (locale === "fr") return fr_listing_status_draft(inputs)
	if (locale === "de") return de_listing_status_draft(inputs)
	if (locale === "ja") return ja_listing_status_draft(inputs)
	if (locale === "zh") return zh_listing_status_draft(inputs)
	if (locale === "ar") return ar_listing_status_draft(inputs)
	if (locale === "id") return id_listing_status_draft(inputs)
	if (locale === "it") return it_listing_status_draft(inputs)
	if (locale === "ru") return ru_listing_status_draft(inputs)
	if (locale === "pt") return pt_listing_status_draft(inputs)
	return ko_listing_status_draft(inputs)
});